import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { validationsQuestionsDynamiques } from 'src/app/shared/questionnaire.metadata';
import { FormulaireService } from '../../formulaire.service';
import { ModeRenduService } from '../../mode-rendu/mode-rendu.service';
import { SaisieService } from '../../saisie.service';

@Component({
  selector: 'bis-liste-bav',
  templateUrl: './liste-bav.component.html',
  styleUrls: ['./liste-bav.component.css']
})
export class ListeBavComponent implements OnInit {
  public rootForm: UntypedFormGroup;
  step: number = 0;
  @Input()
  erreursMap: Map<string, string>;
  
  constructor(
    private formulaireService: FormulaireService,
    public modeRenduService: ModeRenduService,
    public saisieService: SaisieService
  ) {
    this.rootForm = this.formulaireService.getRootForm();
    if (! this.listeBav) {
      (this.rootForm.get('dg') as UntypedFormGroup).setControl('listeBav', new UntypedFormArray([]));
    }
    if (! this.detailBavs) {
      (this.rootForm.get('bav') as UntypedFormGroup).setControl('detailBavs', new UntypedFormArray([]));
    }
    if (! this.lieuxBav) {
      (this.rootForm.get('moyens') as UntypedFormGroup).setControl('lieuxBav', new UntypedFormArray([]));
    }
   }

  ngOnInit() {
    this.trierListeBav();
  }

  get listeBav() {
    return this.rootForm.get('dg').get('listeBav') as UntypedFormArray;
  }

  get detailBavs() {
    return this.rootForm.get('bav').get('detailBavs') as UntypedFormArray;
  }

  get lieuxBav() {
    return this.rootForm.get('moyens').get('lieuxBav') as UntypedFormArray;
  }
  
  public get formulaire(): UntypedFormGroup {
    return this.rootForm.get('dg') as UntypedFormGroup;
  }

  public ajouterBav() {
    // on récupère le nombre total avant ajout
    let nbBav = this.formulaire.get('xxBavNb').value;

    // Pour les validators, on utilise ce qui est dans le questionnaire.metadata
    // Pour la boucle sur les BAV onglet DG = référence
    this.listeBav.push(new UntypedFormGroup({
      xxBavRang: new UntypedFormControl(this.listeBav.length, Validators.required),
      xxBavIelst: new UntypedFormControl('', validationsQuestionsDynamiques.get('xxBavIelst'))
    }));
    // Pour la boucle sur les BAV onglet BAV
    this.detailBavs.push(new UntypedFormGroup({
      bavRang: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavRang')),
      bavIelst: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavIelst')),
      bavAaNbAav: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbAav')),
      bavAaNbJur: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbJur')),
      bavAaNbPsy: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbPsy')),
      bavAaNbWsoc: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbWsoc')),
      bavAaNbAutrInterv: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbAutrInterv')),
      bavAaNbDir: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbDir')),
      bavAaNbComptsecr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbComptsecr')),
      bavAaNbAutrSupport: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbAutrSupport')),
      bavAaNbTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaNbTot')),
      bavAaEtpAav: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpAav')),
      bavAaEtpJur: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpJur')),
      bavAaEtpPsy: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpPsy')),
      bavAaEtpWsoc: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpWsoc')),
      bavAaEtpAutrInterv: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpAutrInterv')),
      bavAaEtpDir: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpDir')),
      bavAaEtpComptsecr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpComptsecr')),
      bavAaEtpAutrSupport: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpAutrSupport')),
      bavAaEtpTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavAaEtpTot')),
      bavBbPremContactOrigAsso: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavBbPremContactOrigAsso')),
      bavBbPremContactOrigPerso: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavBbPremContactOrigPerso')),
      bavBbPremContactOrigTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavBbPremContactOrigTot')),
      bavBbPremContactModeEcrit: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavBbPremContactModeEcrit')),
      bavBbPremContactModeTel: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavBbPremContactModeTel')),
      bavBbPremContactModePres: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavBbPremContactModePres')),
      bavBbPremContactModeTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavBbPremContactModeTot')),
      bavCcRecuVictNb: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuVictNb')),
      bavCcRecuVictSuivi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuVictSuivi')),
      bavCcRecuVictEntret: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuVictEntret')),
      bavCcRecuNvictNb: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuNvictNb')),
      bavCcRecuNvictSuivi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuNvictSuivi')),
      bavCcRecuNvictEntret: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuNvictEntret')),
      bavCcRecuNbTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuNbTot')),
      bavCcRecuSuiviTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuSuiviTot')),
      bavCcRecuEntretTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuEntretTot')),
      bavCcRecuVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuVict')),
      bavCcRecuVictPc: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuVictPc')),
      bavCcRecuVictAud: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavCcRecuVictAud')),
      bavDdFaitPersoHomiVolo: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoHomiVolo')),
      bavDdFaitPersoSexuel: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoSexuel')),
      bavDdFaitPersoProxe: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoProxe')),
      bavDdFaitPersoViolen: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoViolen')),
      bavDdFaitPersoHomiInvolo: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoHomiInvolo')),
      bavDdFaitPersoBless: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoBless')),
      bavDdFaitPersoAband: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoAband')),
      bavDdFaitPersoMenace: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoMenace')),
      bavDdFaitPersoDiscri: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoDiscri')),
      bavDdFaitPersoAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoAutr')),
      bavDdFaitPersoAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavDdFaitPersoAutrDet')),
      bavDdFaitPersoTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitPersoTot')),
      bavDdFaitBienVolSimp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitBienVolSimp')),
      bavDdFaitBienVolAggr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitBienVolAggr')),
      bavDdFaitBienEscro: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitBienEscro')),
      bavDdFaitBienDegrad: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitBienDegrad')),
      bavDdFaitBienAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitBienAutr')),
      bavDdFaitBienAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavDdFaitBienAutrDet')),
      bavDdFaitBienTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitBienTot')),
      bavDdFaitCircuBless: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitCircuBless')),
      bavDdFaitCircuDegat: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitCircuDegat')),
      bavDdFaitCircuTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitCircuTot')),
      bavDdFaitAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitAutr')),
      bavDdFaitAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavDdFaitAutrDet')),
      bavDdFaitTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavDdFaitTot')),
      bavEeEntretPsy: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeEntretPsy')),
      bavEeEntretJur: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeEntretJur')),
      bavEeEntretSoc: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeEntretSoc')),
      bavEeEntretEcout: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeEntretEcout')),
      bavEeEntretAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeEntretAutr')),
      bavEeEntretAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeEntretAutrDet')),
      bavEeEntretTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeEntretTot')),
      bavEeDiliJur: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliJur')),
      bavEeDiliCivi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliCivi')),
      bavEeDiliFondGaran: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliFondGaran')),
      bavEeDiliSarvi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliSarvi')),
      bavEeDiliPenit: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliPenit')),
      bavEeDiliPolgend: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliPolgend')),
      bavEeDiliAvoc: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliAvoc')),
      bavEeDiliHuis: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliHuis')),
      bavEeDiliOrgaSoc: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliOrgaSoc')),
      bavEeDiliColter: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliColter')),
      bavEeDiliPref: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliPref')),
      bavEeDiliOrgaLogt: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliOrgaLogt')),
      bavEeDiliHebgt: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliHebgt')),
      bavEeDiliHosto: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliHosto')),
      bavEeDiliAsso: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliAsso')),
      bavEeDiliAssur: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliAssur')),
      bavEeDiliSad: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliSad')),
      bavEeDiliFrserv: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliFrserv')),
      bavEeDiliAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliAutr')),
      bavEeDiliAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeDiliAutrDet')),
      bavEeDiliTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiliTot')),
      bavEeAideCivi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAideCivi')),
      bavEeAideSarvi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAideSarvi')),
      bavEeProcPreSentenPlainte: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPreSentenPlainte')),
      bavEeProcPreSentenEnq: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPreSentenEnq')),
      bavEeProcPreSentenCss: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPreSentenCss')),
      bavEeProcPreSentenPc: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPreSentenPc')),
      bavEeProcPreSentenAud: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPreSentenAud')),
      bavEeProcPreSentenAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPreSentenAutr')),
      bavEeProcPreSentenAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeProcPreSentenAutrDet')),
      bavEeProcPreSentenTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPreSentenTot')),
      bavEeProcPostSentenDec: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPostSentenDec')),
      bavEeProcPostSentenDef: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPostSentenDef')),
      bavEeProcPostSentenRecour: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPostSentenRecour')),
      bavEeProcPostSentenAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPostSentenAutr')),
      bavEeProcPostSentenAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeProcPostSentenAutrDet')),
      bavEeProcPostSentenTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeProcPostSentenTot')),
      bavEeAuteurPreSentenCj: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPreSentenCj')),
      bavEeAuteurPreSentenDp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPreSentenDp')),
      bavEeAuteurPreSentenFinDeten: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPreSentenFinDeten')),
      bavEeAuteurPreSentenFinMes: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPreSentenFinMes')),
      bavEeAuteurPreSentenAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPreSentenAutr')),
      bavEeAuteurPreSentenAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeAuteurPreSentenAutrDet')),
      bavEeAuteurPreSentenTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPreSentenTot')),
      bavEeAuteurPostSentenMilFer: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPostSentenMilFer')),
      bavEeAuteurPostSentenMilOuv: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPostSentenMilOuv')),
      bavEeAuteurPostSentenFinDeten: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPostSentenFinDeten')),
      bavEeAuteurPostSentenFinMes: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPostSentenFinMes')),
      bavEeAuteurPostSentenAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPostSentenAutr')),
      bavEeAuteurPostSentenAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeAuteurPostSentenAutrDet')),
      bavEeAuteurPostSentenTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeAuteurPostSentenTot')),
      bavEeDiPreSentenCivi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPreSentenCivi')),
      bavEeDiPreSentenAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPreSentenAutr')),
      bavEeDiPreSentenAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeDiPreSentenAutrDet')),
      bavEeDiPreSentenTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPreSentenTot')),
      bavEeDiPostSentenCivi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPostSentenCivi')),
      bavEeDiPostSentenSarvi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPostSentenSarvi')),
      bavEeDiPostSentenHuis: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPostSentenHuis')),
      bavEeDiPostSentenJapSpip: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPostSentenJapSpip')),
      bavEeDiPostSentenFondGar: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPostSentenFondGar')),
      bavEeDiPostSentenAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPostSentenAutr')),
      bavEeDiPostSentenAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeDiPostSentenAutrDet')),
      bavEeDiPostSentenTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDiPostSentenTot')),
      bavEeFoncJudic: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeFoncJudic')),
      bavEeDemarPlainte: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDemarPlainte')),
      bavEeDemarAj: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDemarAj')),
      bavEeDemarAud: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDemarAud')),
      bavEeDemarAccomp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDemarAccomp')),
      bavEeDemarDi: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDemarDi')),
      bavEeDemarAutr: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDemarAutr')),
      bavEeDemarAutrDet: new UntypedFormControl('', validationsQuestionsDynamiques.get('bavEeDemarAutrDet')),
      bavEeDemarTot: new UntypedFormControl(null, validationsQuestionsDynamiques.get('bavEeDemarTot'))
    }));
    // Pour la boucle sur les BAV pour les lieux de permanence BAV
    this.lieuxBav.push(new UntypedFormGroup({
      aaLieuBavRang: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuBavRang')),
      aaLieuBavIelst: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuBavIelst')),
      aaLieuBavQp: new UntypedFormControl('', validationsQuestionsDynamiques.get('aaLieuBavQp')),
      aaLieuBavNbPerm: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuBavNbPerm')),
      aaLieuBavNbPermEtp: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuBavNbPermEtp')),
      aaLieuBavNbVict: new UntypedFormControl(null, validationsQuestionsDynamiques.get('aaLieuBavNbVict'))
    }));

    this.step = this.listeBav.length - 1 ;
    this.saisieService.ajoutValidateurCroiseBAV(this.detailBavs, this.detailBavs.length - 1);
    this.saisieService.ajoutValidateurCroiseLieuxBav(this.lieuxBav, this.lieuxBav.length - 1);

    // on incrémente le nombre total de bav
    this.formulaire.get('xxBavNb').setValue(++nbBav);
  }

  public supprimerBav(index?: number) {
    if (index >= 0) {
      const bavValeur = this.listeBav.controls[index].value;
      if (confirm(`Êtes vous sûr de supprimer ${bavValeur['xxBavIelst']} ?`)) {
        this.listeBav.removeAt(index);
        this.detailBavs.removeAt(index);
        this.lieuxBav.removeAt(index);
      }
    } else {
      this.listeBav.removeAt(this.listeBav.length - 1);
      this.detailBavs.removeAt(this.listeBav.length - 1);
      this.lieuxBav.removeAt(this.listeBav.length - 1);
    }
    // On maj les rangs
    this.majRangs();
    // on met à jour le nombre total de bav
    this.formulaire.get('xxBavNb').setValue(this.listeBav.controls.length);
  }

  public setStep(index: number): void {
    this.step = index;
  }

  private trierListeBav(): void {
    this.listeBav.controls.sort((a, b) => {
      if (a.get('xxBavRang').value < b.get('xxBavRang').value) {
            return -1;
      } else if (a.get('xxBavRang').value > b.get('xxBavRang').value) {
            return 1;
      } else {
            return 0;
      }
    });
  }

  private majRangs(): void {
    for (let index = 0; index < this.listeBav.length; index++) {
      this.listeBav.controls[index].get('xxBavRang').setValue(index);
    }

    this.trierListeBav();
  }

  public xxBavIelst(index: number): string {
    let resultat = '';
    if (this.listeBav.controls[index].get('xxBavIelst') !== null) {
      resultat = this.listeBav.controls[index].get('xxBavIelst').value;
    }
    return resultat;
  }

}


